export default __webpack_public_path__ + "static/media/Opificio-Light.e918267f.ttf";